// hooks/useNavbarHeight.ts
import { useState, useEffect } from 'react';

export const useNavbarHeight = (navbarSelector: string = 'nav') => {
  const [navbarHeight, setNavbarHeight] = useState(64); // Default height

  useEffect(() => {
    const updateNavbarHeight = () => {
      const navbar = document.querySelector(navbarSelector);
      if (navbar) {
        const height = navbar.getBoundingClientRect().height;
        setNavbarHeight(height);
      }
    };

    // Initial update
    updateNavbarHeight();
    
    // Update on resize
    window.addEventListener('resize', updateNavbarHeight);
    
    // Also update on scroll in case of dynamic navbars that change height on scroll
    window.addEventListener('scroll', updateNavbarHeight);
    
    // Use MutationObserver to detect changes to the navbar (like class changes)
    const navbar = document.querySelector(navbarSelector);
    let observer: MutationObserver | null = null;
    
    if (navbar) {
      observer = new MutationObserver(updateNavbarHeight);
      observer.observe(navbar, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style']
      });
    }
    
    return () => {
      window.removeEventListener('resize', updateNavbarHeight);
      window.removeEventListener('scroll', updateNavbarHeight);
      if (observer) {
        observer.disconnect();
      }
    };
  }, [navbarSelector]);

  return navbarHeight;
};